import { getKeys } from '../../adapters/utils';
import { get } from '../../utils/get';
export var IDs = {
    ORDER_PAGE_URL: 'restaurants-order-page.page-url',
};
var SchemaTypes = {};
var userVisible = [];
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        if (!get(item, 'menu')) {
            return {};
        }
        return _a = {},
            _a[IDs.ORDER_PAGE_URL] = get(item, 'menu'),
            _a;
    },
    getSdStatus: function () { },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
};
